import { subsection_finnmarkskommisjonen, subsection_innstillingsradet } from '../../../Models/Constants/Subsections';

export enum ThemePageType {
    EnkeltDomstol = 0,
    Finnmarkskommisjonen = 10,
    Innstillingsradet = 20,
}

export const getThemePageTypeName = (value: ThemePageType): string => {
    switch (value) {
        case ThemePageType.Finnmarkskommisjonen:
            return subsection_finnmarkskommisjonen;
        case ThemePageType.Innstillingsradet:
            return subsection_innstillingsradet;
        default:
            return '';
    }
};
